import { connect } from 'react-redux'

import component from 'components/Uoms'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  uoms: state.uoms
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Uoms/containers/UomsContainer.js